// frontend/modules/internal-account/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import InternalAccountManagementView from './views/InternalAccountManagementView';
import InternalAccountFormView from './views/InternalAccountFormView';
import TransaccManagementView from './views/TransaccManagementView';
import TransaccFormView from './views/TransaccFormView';

export const internalAccountRoutes: RouteObject[] = [
    {
        path: '/accounts/internal',
        element: <InternalAccountManagementView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/accounts/internal/new',
        element: <InternalAccountFormView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/accounts/internal/edit/:branch/:glNo/:acNo',
        element: <InternalAccountFormView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/accounts/transacc',
        element: <TransaccManagementView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/accounts/transacc/new',
        element: <TransaccFormView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/accounts/transacc/edit/:glNo/:acNo',
        element: <TransaccFormView />,
        errorElement: <ErrorBoundary />
    }
];
